import React from "react";
import { ChatTurn } from "./chatBotTypes";
import ChatHistoryTurn from "./ChatHistoryTurn";

type Props = {
  turns: ChatTurn[];
  authId: string;
  platformId?: string;
  leagueId?: string;
  teamName?: string;
  onShareMessage: (messageId: string) => void;
  isCheckmark?: boolean;
  /** When true, a new turn is in progress so no history turn keeps always-visible thumbs */
  hasActiveTurn?: boolean;
  /** Ref for the latest history turn (pin-to-top scroll / dynamic spacer) */
  latestTurnRef?: React.Ref<HTMLDivElement>;
};

const ChatHistoryList = ({
  turns,
  authId,
  platformId,
  leagueId,
  teamName,
  onShareMessage,
  isCheckmark,
  hasActiveTurn = false,
  latestTurnRef,
}: Props) => (
  <>
    {turns.map((turn, index) => {
      const isLatestTurn = !hasActiveTurn && index === turns.length - 1;
      return (
        <ChatHistoryTurn
          key={turn.messageId ?? `chat-turn-${index}`}
          turn={turn}
          authId={authId}
          platformId={platformId}
          leagueId={leagueId}
          teamName={teamName}
          onShareMessage={onShareMessage}
          isCheckmark={isCheckmark}
          isLatestTurn={isLatestTurn}
          turnRef={isLatestTurn ? latestTurnRef : undefined}
        />
      );
    })}
  </>
);

const areListPropsEqual = (prev: Props, next: Props) =>
  prev.turns === next.turns &&
  prev.authId === next.authId &&
  prev.platformId === next.platformId &&
  prev.leagueId === next.leagueId &&
  prev.teamName === next.teamName &&
  prev.onShareMessage === next.onShareMessage &&
  prev.isCheckmark === next.isCheckmark &&
  prev.hasActiveTurn === next.hasActiveTurn &&
  prev.latestTurnRef === next.latestTurnRef;

export default React.memo(ChatHistoryList, areListPropsEqual);
